import React, { useState } from 'react'
import PropTypes from 'prop-types'
import FlexRow from '../../../../components/molecules/FlexRow'
import FadeIn from '../../../../components/molecules/Transitions/FadeIn'
import NavIconButton from './NavIconButton'

function NavbarTitle ({ open, onIconClick }) {
  const [hover, setHover] = useState(false)

  if (!open) {
    return (
      <FlexRow className='gap-sm px-2 items-center mb-1'>
        <NavIconButton icon='verticalSplit' onClick={onIconClick} size={24} />
      </FlexRow>
    )
  }

  return (
    <FlexRow className='gap-sm px-2 items-center mb-2'>
      <NavIconButton icon={hover ? 'firstPage' : 'verticalSplit'} onClick={onIconClick} size={24} onHover={setHover} />
      <FadeIn className='font-size-lg font-serif flex items-center gap-xs flex-row' style={{ lineHeight: '32px' }}>
        <span>Denali</span>
        <em>AI</em>
      </FadeIn>
    </FlexRow>
  )
}

NavbarTitle.propTypes = {
  open: PropTypes.bool.isRequired,
  onIconClick: PropTypes.func.isRequired
}

NavbarTitle.defaultProps = {
  open: false
}

export default NavbarTitle
